module.exports = __webpack_public_path__ + "static/img/corenrDownloadOne.ba71459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrDownloadOne.png
// module id = 7Dyb
// module chunks = 1